import { Divider, Icon, List, ListItem, ListItemIcon, ListItemText, Tooltip } from "@mui/material";
import React,{useState,useEffect} from "react";
import { useHistory, withRouter, Link as RLink } from "react-router-dom";

import { useDispatch,useSelector } from "react-redux";

const AppSideMenu:React.FC<any> = (props:any)=>{
    
    const role = useSelector((state:any)=>state.user.role);

    const menuList = useSelector((state:any)=>state.user?state.user.settings.menu:null);
    const currentAppId = useSelector((state:any)=>state.currentApp.id);
    
    const [MenuList,setMenuList]:any = useState();
    
    useEffect(()=>{
        let appMenu = menuList.filter((item:any)=> item.app_id == currentAppId);
        setMenuList(appMenu);
    },[currentAppId]);

    return (
        <>
            <List>
                <Tooltip title="home" placement="right-start" componentsProps={{tooltip: {sx: {bgcolor: '#11417f',},},}}>
                    <ListItem button component={RLink} to={'/'} onClick={props.onClick} >
                        <ListItemIcon>
                            <Icon color="primary">home</Icon>
                        </ListItemIcon>
                        <ListItemText primary={'Home'} />
                    </ListItem>
                </Tooltip>
                {MenuList && MenuList.map((m:any,key:number)=>(
                    <Tooltip title={m.name}  key={key} placement="right-start" componentsProps={{tooltip: {sx: {bgcolor: '#11417f',},},}} >
                        <ListItem button component={RLink} to={m.path} onClick={props.onClick} >
                            <ListItemIcon>
                                <Icon color="primary">{m.icon}</Icon>
                            </ListItemIcon>
                            <ListItemText primary={m.name} />
                        </ListItem>
                    </Tooltip>
                ))}
                {role == 'Admin' && 
                    <Tooltip title="Admin" placement="right-start" componentsProps={{tooltip: {sx: {bgcolor: '#11417f',},},}}>
                        <ListItem button component={RLink} to={'/admin'} onClick={props.onClick} >
                            <ListItemIcon>
                                <Icon color="primary">admin_panel_settings</Icon>
                            </ListItemIcon>
                            <ListItemText primary={'Admin'} />
                        </ListItem>
                    </Tooltip>
                }
          </List>
          <Divider />
        </>
    );
}

export default AppSideMenu;